// Policies: pages/privacy-policy.html | terms-conditions.html | warranty-policy.html (key from <body data-p>)
(function () {
  const e = LC.escape;
  const policies = window.LC_POLICIES || {};
  const files = { privacy: 'privacy-policy', terms: 'terms-conditions', warranty: 'warranty-policy' };
  const metas = {
    privacy: 'Read the Le Chic Beauty privacy policy: what personal information we collect, how we use and share it, and your privacy rights, including California (CCPA/CPRA) rights.',
    terms: 'Read the Le Chic Beauty terms and conditions for using our website and purchasing hair tools, hair care and hair extensions.',
    warranty: 'Le Chic Beauty Limited Lifetime Warranty: coverage for registered hair tools, eligibility, what is and isn’t covered, how to submit a claim and shipping fees.'
  };
  let key = LC.param('p');
  if (!policies[key]) key = 'privacy';
  const policy = policies[key];
  const path = LC.pageUrl(files[key]);

  // Store copy marks sections as uppercase paragraphs and "•" lines; give them real structure
  const titleCase = (s) => s.toLowerCase().replace(/\b([a-z])/g, (m) => m.toUpperCase());
  const body = policy.body
    .replace(/<p>\s*([A-Z0-9][A-Z0-9 \-–&amp;"'’,.:/()]{3,90}?)\s*<\/p>/g, (m, t) => {
      if (/[a-z]/.test(t)) return m;
      return `<h2>${titleCase(t.replace(/^SECTION\s+\d+\s*[-–:]\s*/, ''))}</h2>`;
    })
    .replace(/(?:<p>\s*•\s*[\s\S]*?<\/p>\s*)+/g, (block) =>
      `<ul>${block.match(/<p>\s*•\s*([\s\S]*?)<\/p>/g).map((p) => `<li>${p.replace(/<p>\s*•\s*|<\/p>/g, '').trim()}</li>`).join('')}</ul>`);

  const tabs = Object.keys(policies).map((k) =>
    `<a class="tab${k === key ? ' is-active' : ''}" href="${LC.pageUrl(files[k])}"${k === key ? ' aria-current="page"' : ''}>${e(policies[k].title)}</a>`
  ).join('');

  document.getElementById('policy-main').innerHTML = `
    <section class="help-hero">
      <div class="container">
        <nav class="breadcrumb" aria-label="Breadcrumb">
          <ol><li><a href="index.html">Home</a></li><li aria-current="page">${e(policy.title)}</li></ol>
        </nav>
        <p class="chip">Policies</p>
        <h1>Le Chic Beauty ${e(policy.title)}</h1>
        ${policy.updated ? `<p class="help-intro">Last updated ${e(policy.updated)}</p>` : ''}
        <nav class="help-tabs" aria-label="Policies">${tabs}</nav>
      </div>
    </section>
    <section class="section">
      <div class="container policy-layout">
        <div class="article-body policy-body">${body}</div>
        <aside class="policy-aside">
          <h2>Questions?</h2>
          <p>Le Chic Beauty Customer Care is happy to help with anything in this policy. Email <a href="mailto:${LC.EMAIL}">${LC.EMAIL}</a>.</p>
          <a class="btn btn-dark" href="pages/contact.html">Contact Us</a>
          ${key === 'warranty' ? '<a class="link-arrow" href="pages/warranty-claim.html">Start a warranty claim <span aria-hidden="true">→</span></a><a class="link-arrow" href="pages/register-your-tool.html">Register your tool <span aria-hidden="true">→</span></a>' : ''}
        </aside>
      </div>
    </section>`;

  const title = `${policy.title} | Le Chic Beauty`;
  LC.seo({
    title,
    description: metas[key],
    path,
    jsonld: [
      LC.webPageLd('WebPage', path, title, metas[key], { breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` } }),
      Object.assign(LC.breadcrumbLd([['Home', 'index.html'], [policy.title, path]]), { '@id': `${LC.abs(path)}#breadcrumb` })
    ]
  });
})();
